// Vendor imports
const history = require('history')

// Work-around for https://app.asana.com/0/102902769366319/882764127630880/f
function isBrowserHistorySupported() {
  try {
    return !!window.history.length
  } catch (err) {
    return false
  }
}

function createHistory(store) {
  if (isBrowserHistorySupported()) {
    return history.createBrowserHistory()
  }
  const state = store.getState()
  const initialEntries = [ state.router.location.href ]
  return history.createMemoryHistory({ initialEntries })
}

module.exports = {
  isBrowserHistorySupported,
  createHistory
}
